import { ActivatedRoute } from '@angular/router';
import { HostListener, Component, OnInit, Input, Output, AfterContentChecked, EventEmitter, Type } from '@angular/core';
import { AppConfig } from '../config/app.config';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { PackagingCodeService } from './packaging-code.service';
import { PictureBe } from '../../app/image-library/shared/image-model';
import { ImageCommon } from '../image-library/image-common';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum, StatusEnum } from '../shared/enums.model';
import { PackagingCodeBe, PackagingCodeListBe, PkgCodeBE, PictureBE, PkgCodeCompositionBE, PkgCodeConstraintBE } from './shared/packaging-code.model';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { PackagingMaterialSearchDlgComponent } from '../../app/packaging-material/search-packaging-material.component';
import { PackagingCodeSearchDlgComponent } from './search-packaging-code.component';
import { SetFocus } from '../../app/shared/setFocus';
import { PackagingMaterialListBE } from '../../app/packaging-material/shared/packaging-material.model';
import { UserHandling } from '../shared/user-handling';
import { isDefined } from '@angular/compiler/src/util';
import { PackagingMaterialService } from '../../app/packaging-material/packaging-material.service';
import { forEach } from '@angular/router/src/utils/collection';
import { ConfirmComponent } from '../dialogboxes/confirm.component';
import { ConfirmResult } from '../dialogboxes/shared/confirm.model';
import { isEmpty } from 'rxjs/operator/isEmpty';
import { ChineseChangeValueService } from '../chinese-change-value.service';

declare var jQuery: any;
const Min_PkgCode_Length = 2;

@Component({
    moduleId: module.id,
    selector: 'packaging-code',
    templateUrl: 'packaging-code.html',
    styleUrls: ['packaging-code.css'],
    providers: [PackagingCodeService, PackagingMaterialService,ChineseChangeValueService]
})
export class PackagingCodeComponent implements OnInit, AfterContentChecked, ComponentCanDeactivate {

    setFocus: SetFocus = new SetFocus();
    isFocusSet: boolean = false;


    constructor(private modalService: NgbModal,
        private errHandler: ErrorHandlerService,
        private _route: ActivatedRoute,
        private packagingCodeService: PackagingCodeService,
        private config: AppConfig,
        private packagingMaterialService: PackagingMaterialService,
        public ChineseChangeValueService:ChineseChangeValueService ) {

    }

    @Input() codeIdFromParentCtrl: number;
    isDirty: boolean = false;
    showSpinner: boolean = false;
    showCodeSearchSpinner: boolean = false;
    code: PkgCodeBE = null;
    editMode: boolean = false;
    selectedCodeId: number;
    isEditMode: boolean = false;

    //to check if name is unique
    orgName: string = "";
    nameExistsClass: string = "";


    // Image
    image1: any;
    imageLibraryEvent: PictureBe;
    addImageDlg: NgbModalRef;
    pictureLabels: string = "";
    codeTitle:string = "";
    imageSearchResult: PictureBe[] = [];
    selectedImages: Array<number> = [];
    pictureIdS: Array<number> = [];
    deleteImageInfo: PictureBe;
    @Output() piImageId: Array<number> = [];

    // Button bar 
    btnDuplicateVisible: boolean = true;
    btnNewVisible: boolean = true;
    btnActivateVisible: boolean = false;
    btnPreviewVisible: boolean = false;
    btnSaveVisible: boolean = true;
    btnApproveVisible: boolean = false;
    btnHistoryVisible: boolean = false;
    btnDeleteVisible: boolean = true;

    // misc
    user: UserHandling = new UserHandling();
    newMaterialText: string = '';
    codeControlNameToSet: string = "";
    pendingAction: any = null;

    //new string list for stack status
    dropdownOptions:string[]=[
        '',
        'Can both be on top or below another packaging',
        ' Only on top of another packaging',
        ' Only on the same material type / load carrier',
        'Not stackable',
    ];
    // confirm dialog
    dialogAction: string;
    dialogBtnType: string;
    dialogAppliesTo: string = "";
    dialogAppliesToId: number = -1;
    confirmDlgText: string = "";
    currentDlg: NgbModalRef;

    pkgCodePageLabel: string = '';
    statusSelected: number = 1;
    //new lines for default stack status 
    stackStatusSelected:string=this.dropdownOptions[0];//default value 

    
    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return !this.isDirty;
    }

    ngOnInit() {
        this.showCodeSearchSpinner = true;
        var id = +this._route.snapshot.params["codeId"];
        if (isNaN(id) || id < 1) {
            if (!isNaN(this.codeIdFromParentCtrl) || id > 0)
                id = this.codeIdFromParentCtrl;
            else {
                this.codeIdFromParentCtrl = null;
                this.showSpinner = false;
            }
        }

        id > 0
            ? this.getCode(id)
            : id = null;

    }


    ngAfterContentChecked() {
        this.isFocusSet = this.setFocus.to("PackagingCode", this.isFocusSet);
    }

    setEditMode(editMode: boolean) {
        if (this.isDirty) {
            var confirmed = confirm("You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.");
            if (confirmed) {
                this.isDirty = false;
                this.isEditMode = editMode;
            }
        }
        else {
            this.code = null;
            this.isEditMode = editMode;
        }
    }


    onSearchCodeExecute(codeId: number) {
        this.getCode(codeId);
        this.setEditMode(true);
    }


    getCode(codeId: number) {
        this.errHandler.emitErrorObject(null);
        this.packagingCodeService.getPkgCodeFor(codeId)
            .subscribe(returnObject => this.searchCodeResponse(returnObject));
    }
    //for dummy data storage
values:any[]=[];

    searchCodeResponse(returnObject: IReturnObject) {
        console.log(returnObject)
        if (returnObject.
            ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingCodeComponent.searchCodeResponse', returnObject.ErrorType);
        }
        else {
            
            this.setResponsePkgCode(returnObject);

        }

        this.showCodeSearchSpinner = false;
    }

    checkNameUnique() {
        if (this.code.PackagingCode.length < Min_PkgCode_Length) {
            this.nameExistsClass = "";
            return;
        }

        if (this.code.PackagingCode == this.orgName) {
            this.nameExistsClass = "";
            return;
        }

        this.packagingCodeService.codeExist(this.code.PackagingCode)
            .subscribe(nameExists => this.checkNameUniqueResponse(nameExists));
    }

    checkNameUniqueResponse(nameExists: boolean) {
        if (nameExists)
            this.nameExistsClass = "nameExist";
        else
            this.nameExistsClass = "";
    }

    onSearchCodeDialogExecute(pkgCodeId: any) {
        if (pkgCodeId == null) {
            this.closeDlg();
            return;
        }

        this.packagingCodeService.getPkgCodeContraintInfo(pkgCodeId)
            .subscribe(returnObject => this.selectedCodeResponse(returnObject));
    }

    selectedCodeResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorMsg != "") {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingCodeComponent.selectedCodeResponse',
                ErrorTypeEnum.Error);
            return;
        }

        if (returnObject.DataList.length > 0) {
            if (!this.code.Constraints.some(x => x.CodeConstraintId === returnObject.DataList[0].CodeConstraintId)) {
                returnObject.DataList[0].CodeId = this.selectedCodeId;
                this.code.Constraints.push(returnObject.DataList[0]);
                this.setWeights();
                this.setDirty();
                this.closeDlg();
                this.info("The Code is added successfully: " + returnObject.DataList[0].Code);
            }
            else {
                this.info("The code was already added before: " + returnObject.DataList[0].Code);
            }
        }
    }

    onSearchMaterialDialogExecute(dialogResult: PackagingMaterialListBE[]) {
        if (dialogResult == null) {
            this.closeDlg();
            return;
        }

        if (this.code.Compositions === null) {
            this.code.Compositions = new Array<PkgCodeCompositionBE>();
        }

        var i: number;
        var materialAlreadyExist: boolean = false;
        for (i = 0; i < dialogResult.length; i++) {
            if (!this.code.Compositions.some(x => x.MaterialId === dialogResult[i].Id)) {
                var item: PkgCodeCompositionBE = new PkgCodeCompositionBE();
                item.CodeCompositionId = this.selectedCodeId;
                item.MaterialId = dialogResult[i].Id;
                item.MHNO = dialogResult[i].MHNo;
                item.Quantity = 1;
                item.Description = dialogResult[i].Description;
                item.Level = 1;
                item.MaterialUnitWeight = dialogResult[i].Weight

                this.code.Compositions.push(item);
                this.setDirty();

                this.info("The Material is added successfully: " + dialogResult[i].MHNo);
            }
            else {
                this.info("The Material was already added before: " + dialogResult[i].MHNo);
            }
        }

        this.setWeights();
        this.closeDlg();
    }

    // ----------------------------------------------------------
    // Images handling
    // ----------------------------------------------------------
    extractImages() {
        this.pictureIdS = [];
        ImageCommon.SetBase64Image(this.code.Pictures);
        this.code.Pictures.forEach(x=>this.pictureIdS.push(x.Id));
        this.pictureLabels = ImageCommon.setPictureLabels(this.code.Pictures);
        this.piImageId = this.pictureIdS;
    }

    selectImageToMaterial(addedImage: any) {
        if (this.selectedImages.indexOf(addedImage.Id) === -1) {
            this.selectedImages.push(addedImage.Id);
            this.imageSearchResult.push(addedImage);
        } else {
            this.selectedImages.splice(this.selectedImages.indexOf(addedImage), 1);
            this.imageSearchResult.splice(this.imageSearchResult.indexOf(addedImage.Id), 1);
            this.imageLibraryEvent = null;
        }
    }

    addImageToMaterial() {
        for (var i = 0; i < this.selectedImages.length; i++) {
            if (this.pictureIdS.indexOf(this.selectedImages[i]) === -1) {
                var imageObj = this.imageSearchResult.find(x => x.Id === this.selectedImages[i]);
                this.code.Pictures.push(imageObj);
                this.pictureIdS.push(this.selectedImages[i]);
            }
        }
        
        this.refreshPictureIds();
        ImageCommon.setPictureLabels(this.code.Pictures);
        this.imageSearchResult = [];
        this.closeAddImageDlg();
        this.info("Image's added.");
        this.setDirty();
    }

    deleteImageFromMaterial(imageId: any) {
        ImageCommon.RemovePic(this.code.Pictures, imageId);
        this.refreshPictureIds();
        this.pictureLabels = ImageCommon.setPictureLabels(this.code.Pictures);
        this.info("The picture was removed from the code.");
        this.closeDlg();
        this.setDirty();
    }

    refreshPictureIds(){
        this.pictureIdS = []
        this.code.Pictures.forEach(x=>this.pictureIdS.push(x.Id));
    }

    closeAddImageDlg() {
        this.imageSearchResult = [];
        this.selectedImages = [];
        this.closeDlg();
    }

    openAddImage(modal: any) {
        this.currentDlg = this.modalService.open(modal, { size: 'lg' });
    }

    openDeleteImage(modal: any, pictureInfo: any) {
        this.deleteImageInfo = pictureInfo;
        this.currentDlg = this.modalService.open(modal, { size: 'sm' });
    }

    countChange(event: PictureBe) {
        this.imageLibraryEvent = <PictureBe>event;
        this.selectImageToMaterial(this.imageLibraryEvent);
    }


    onBtnBarButtonNotify(command: string, confirmDlg: any): void {
        if (command == "new") {
            if (this.isDirty) {
                this.confirmContinueWithoutSaveForNew(confirmDlg);
            } else {
                this.createNewPackagingCode();
            }
        }

        else if (command == "duplicate") {
            if (this.isDirty) {
                this.confirmContinueWithoutSaveForDuplicate(confirmDlg);
            } else {
                this.createDuplicate();
            }
        }

        else if (command == "save" && this.isDirty && this.isContentValid(confirmDlg))
            this.savePkgCode();

        else if (command == "delete") {
            this.openConfirmDeleteDlg(confirmDlg);
        }

        else if (command == "activate" && this.readyForActivation() && this.isContentValid(confirmDlg))
            this.changeStatus();

    }

    readyForActivation(): boolean {
        if ((this.code.StatusId != StatusEnum.Active) && (!this.isDirty))
            return true;
        return false;
    }

    isContentValid(modal: any): boolean {

        if (!this.isValidNumericValues()) {
            this.openOnSaveValidateDlg(modal, "Some quantity fields are not valid - it must be geater than zero!");
            return false;
        }
        else if (this.code.PackagingCode.length < Min_PkgCode_Length) {
            this.openOnSaveValidateDlg(modal, "Packaging Code field must have minimum 2 characters.");
            return false;
        }
        else if (this.code.Description.trim().length < 1) {
            this.openOnSaveValidateDlg(modal, "Description field must be filled.");
            return false;
        }
        //new lines for validation for a stacking limit 
        else if (this.code.StackingLimit==null)
        {
            this.openOnSaveValidateDlg(modal, "stacking limit on top(g) should be entered.");
            return false;
        }
        else if (this.stackStatusSelected.trim().length<1)
        {
            this.openOnSaveValidateDlg(modal, "stackability should be selected.");
            return false;
        }
        else if (this.code.Compositions.length == 0) {
            this.openOnSaveValidateDlg(modal, "Packaging Code must have minimum 1 composition.");
            return false;
        }
       
        return true;
    }

    isValidNumericValues(): boolean {
        let checkValues: boolean = true;
        for (let item of this.code.Constraints) {
            if (isNaN(item.Quantity)) {
                return !checkValues;
            }
            else if (item.Quantity <= 0) {
                return !checkValues;
            }
        }

        for (let item of this.code.Compositions) {
            if (isNaN(item.Quantity)) {
                return !checkValues;
            }
            else if (item.Quantity <= 0) {
                return !checkValues;
            }
        }

        return checkValues;
    }

    createDuplicate() {
        this.pkgCodePageLabel = "COPY OF" + " " + this.code.PackagingCode;
        this.selectedCodeId = -1;
        this.code.Id = -1;
        this.orgName = '';
        this.nameExistsClass = '';
        this.code.PackagingCode = '';
        this.setDirty();
        this.setStatus(1);
    }


    onConfirmDlgNotify(command: ConfirmResult): void {
        if (command.Action == "delete")
            this.deletePkgCode();
        else if (command.Action == "continuewithoutsaveDuplicatePkgCode") {
            this.currentDlg.close();
            this.createDuplicate();
        }
        else if (command.Action == "continuewithoutsaveNewPkgCode") {
            this.currentDlg.close();
            this.createNewPackagingCode();
        }
        else if (command.Action == "cancel")
            this.currentDlg.close();
        else
            this.currentDlg.close();
    }

    deletePkgCode() {
        this.currentDlg.close();
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.packagingCodeService.deletePkgCode(this.selectedCodeId)
            .subscribe(returnObject => this.deletePkgCodeResponse(returnObject));
    }

    deletePkgCodeResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg,
                'PackagingCodeComponent.deletePkgCodeResponse',
                returnObject.ErrorType);
        }
        else {
            if (returnObject.RecordCount > 0) {
                if (returnObject.DataList[0].Id != -1)
                    this.info('The packaging code was scrapped.');
                else
                    this.info('The packaging code was deleted');
            }

            this.code = new PkgCodeBE();
            this.selectedCodeId = this.code.Id;
            this.isEditMode = false;
            this.showCodeSearchSpinner = false;
        }
        this.showSpinner = false;
    }

    createNewPackagingCode() {
        this.pkgCodePageLabel = "New Packaging Code";
        this.code = new PkgCodeBE();
        this.selectedCodeId = this.code.Id;
        this.pictureIdS = [];
        this.setStatus(1);//Preliminary
        this.orgName = '';
        this.nameExistsClass = '';
        this.isEditMode = true;
        this.showCodeSearchSpinner = false;
        this.stackStatusSelected=this.dropdownOptions[0];
    }

    setWeights() {
        this.code.Weight = this.calculateCompositionsWeight();
    }

    calculateCompositionsWeight(): number {
        let weight: number = 0;
        if (this.code.Compositions.length > 0) {
            this.code.Compositions.forEach(element => {
                weight += (element.Quantity * element.MaterialUnitWeight)
            });
        }
        return weight;
    }

    openAddCompositionMaterial(openmtrldlg: NgbModalRef) {
        this.currentDlg = this.modalService.open(openmtrldlg, { size: 'lg' });
    }

    deleteComposition(selectedcompositionId: PkgCodeCompositionBE) {
        var index = this.code.Compositions.indexOf(selectedcompositionId);
        this.code.Compositions.splice(index, 1)
        this.setWeights();
        this.setDirty();
    }



    changeStatus() {
        this.code.StatusId = StatusEnum.Active;
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.packagingCodeService.changeStatusPkgCode(this.selectedCodeId, this.code.StatusId)
            .subscribe(returnObject => this.activatePkgCodeResponse(returnObject));
    }
    activatePkgCodeResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg,
                'packagingCodeComponent.activatePkgCodeResponse',
                returnObject.ErrorType);
        } else {
            this.setResponsePkgCode(returnObject);
            this.info('The packaging code was activated successfully.');
        }
        this.showSpinner = false;
    }

    savePkgCode() {
        this.showSpinner = true;

        this.code.StatusId = this.statusSelected;
        this.code.Stackability=this.stackStatusSelected;
        this.code.UserId=(this.user.UserId== null ||this.user.UserId.length < 6) ? "":this.user.UserId;

        const tempPkgCode: PkgCodeBE = JSON.parse(JSON.stringify(this.code));
        tempPkgCode.Pictures.forEach(function (item) {
            item.PictureImage = null;
        });

        this.packagingCodeService.savePkgCode(tempPkgCode)
            .subscribe(returnObject => this.savePkgCodeResponse(returnObject));
    }

    savePkgCodeResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg,
                'packagingCodeComponent.savePkgCodeResponse',
                returnObject.ErrorType);
        } else {
            this.setResponsePkgCode(returnObject);
            this.info('The packaging code was saved successfully.');
        }
        this.showSpinner = false;
    }

    setResponsePkgCode(returnObject: IReturnObject) {
      
       // console.log(this.code.Description);
        //debugger;
        this.code = new PkgCodeBE();
        this.code = <PkgCodeBE>returnObject.DataList[0];
        this.extractImages();
        this.codeTitle = this.code.PackagingCode + ' ' + this.code.Description
        this.setWeights();
        this.selectedCodeId = this.code.Id;
        this.orgName = this.code.PackagingCode;
        this.newMaterialText = '';
        this.nameExistsClass = '';
        this.pkgCodePageLabel = '';
        this.isDirty = false;
        this.showSpinner = false;
        this.setStatus(this.code.StatusId);
        this.stackStatusSelected=this.code.Stackability;
       
    }

    setStatus(statusId: number) {
        this.code.StatusId = statusId;
        this.statusSelected = statusId;
    }

    deleteConstraint(selectedCodeConstraint: PkgCodeConstraintBE) {
        var index = this.code.Constraints.indexOf(selectedCodeConstraint);
        this.code.Constraints.splice(index, 1)
        this.setWeights();
        this.setDirty();
    }

    openAddConstraints(openmtrldlg: NgbModalRef) {
        this.currentDlg = this.modalService.open(openmtrldlg, { size: 'lg' });
    }

    // ----------------------------------------------------------
    // Dialog boxes and support methods
    // ----------------------------------------------------------
    openOnSaveValidateDlg(modal: any, text: string) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "savefail";
        this.dialogBtnType = "info";
        this.dialogAppliesTo = 'Packaging Code';
        this.confirmDlgText = text;
        this.dialogAppliesToId = this.selectedCodeId;
        this.currentDlg = this.modalService.open(modal);
    }

    openConfirmDeleteDlg(modal: any) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "delete";
        this.dialogBtnType = "danger";
        this.dialogAppliesTo = 'Packaging Code';
        this.dialogAppliesToId = this.selectedCodeId;
        this.currentDlg = this.modalService.open(modal);
    }

    confirmContinueWithoutSaveForDuplicate(modal: any) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "continuewithoutsaveDuplicatePkgCode";
        this.dialogBtnType = "warning";
        this.dialogAppliesTo = 'Packaging Code';
        this.dialogAppliesToId = this.selectedCodeId;
        this.currentDlg = this.modalService.open(modal);
    }

    confirmContinueWithoutSaveForNew(modal: any) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "continuewithoutsaveNewPkgCode";
        this.dialogBtnType = "warning";
        this.dialogAppliesTo = 'Packaging Code';
        this.dialogAppliesToId = this.selectedCodeId;
        this.currentDlg = this.modalService.open(modal);
    }

    // ----------------------------------------------------------
    // MISC
    // ----------------------------------------------------------
    setDirty() {
        this.isDirty = true;
    }

    closeDlg() {
        this.currentDlg.close();
    }

    info(message: string): void {
        this.errHandler.emitError(message, '', ErrorTypeEnum.Info);
    }

    quantityChanged() {
        this.setWeights();
        this.isDirty = true;
    }

    // ------------------------------------------------------
    //Access rights control
    // ------------------------------------------------------
    isNewMaterialButtonDisabled() {
        return this.selectedCodeId == null || this.isEditDisabled();
    }

    isBtnBarHidden(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsDeveloper)
            && this.codeIdFromParentCtrl == null;

        return !gotAccess;
    }

    isBtnNewDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsDeveloper);

        return !gotAccess;
    }

    isBtnDuplicateDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsDeveloper)
            && this.code != null
            && this.code.Id != -1
            && this.isEditMode;

        return !gotAccess;
    }

    isBtnSaveDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsDeveloper)
            && this.code != null
            &&this.code.PackagingCode!=''
            &&this.code.Description!=''
            && this.code.StackingLimit != null 
            && this.code.StackingLimit >= 0 
            &&this.stackStatusSelected!=''
            &&this.stackStatusSelected!=null
            && this.isDirty
            && this.isEditMode
            && this.nameExistsClass != "nameExist"
            && this.statusSelected != StatusEnum.Scrapped;

        return !gotAccess;
    }

    isBtnDeleteDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsDeveloper)
            && this.code != null
            && this.code.Id != -1
            && this.isEditMode;

        return !gotAccess;
    }

    isSearchHidden(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsScaniaUser
                || this.user.IsPackagingEngineer
                || this.user.IsTestPackager
                || this.user.IsPartSupplierUser
                || this.user.IsPurchaser
                || this.user.IsDeveloper);

        return !gotAccess;
    }

    isStatusDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin || this.user.IsDeveloper)
            && this.code != null;

        return !gotAccess;
    }

    isEditDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsDeveloper)
            && this.code != null
            && (this.code.StatusId != StatusEnum.Scrapped);
            
           

        return !gotAccess;
    }

    isEditDisabledForPkgCodeField(): boolean {
        let enabledPkgCode: boolean = (this.user.IsPackagingAdmin
            || this.user.IsDeveloper)
            && (this.code != null)
            && (this.code.StatusId == StatusEnum.Preliminary);

        return !enabledPkgCode;
    }

 
    setDefaultBackColor() {
        this.nameExistsClass = "";
    }

}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/packaging-code/packaging-code.component.ts